import React, { useEffect } from "react";
import { HeaderScreen } from "./HeaderScreen";
import { ContentScreen } from "./ContentScreen";
import { AsideScreen } from "./AsideScreen";
import { LoadingScreen } from "../helpers/LoadingScreen";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { types } from "../../Helpers/Types";

const ConvertCelcius = (temp, resta = 273.15) =>
  (Number(temp) - Number(resta)).toFixed(1);
export const MainScreen = () => {
  const { sucursal } = useSelector((store) => store.usuario);
  const collapsed = useSelector((state) => state.globalState.HDMenuCollapsed);
  const dispatch = useDispatch();

  useEffect(() => {
    let urlWeather = `https://api.openweathermap.org/data/2.5/weather?appid=524836177a3d15f87cd8648625d4e994&lang=es&q=${sucursal}`;

    fetch(urlWeather)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error en la respuesta del clima");
        }
        return response.json();
      })
      .then((weatherData) => {

        dispatch({
          type: types.clima,
          payload: {
            temperatura: ConvertCelcius(weatherData.main.temp),
            icono: `http://openweathermap.org/img/w/${weatherData.weather[0].icon}.png`,
          },
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div id="hd-contenedor" className={collapsed ? "collapsed" : "expanded"}>
      <LoadingScreen />
      <HeaderScreen />
      <ContentScreen />
      <AsideScreen />
    </div>
  );
};
